export function isAbsoluteUrl(url) {
  return url.startsWith("http");
}
export function isCMSImage(src) {
  return src.startsWith("/cms");
}
export function getPath(src) {
  if (isAbsoluteUrl(src))
    return src;
  return `s3:/${src}`;
}
export function isRelativeNonCdnImage(src) {
  return !isCMSImage(src) && !isAbsoluteUrl(src);
}
export function isNonProxySrc(src) {
  return /(.)+\.(mp4|svg)$/.test(`${src}`);
}
;
